const routes = {
  assinatura: {
    addUser: () => "/assinatura/adicionarUsuario",
    fetch: () => "/assinatura",
    removeUser: userId => `/assinatura/removerUsuario/${userId}`,
    updateAdmin: () => "/assinatura/alterarAdmin",
  },
  auth: {
    confirmacaoConvite: () => "/account/confirmacaoConvite",
    forgetPassword: () => "/account/esqueceuSenha",
    login: () => "/account/login",
    logout: () => "/account/logout",
    reset: () => "/account/resetarSenha",
    update: () => "/account/atualizarSenha",
  },
  buscaCativo: {
    fetch: () => "/relatorioCativo",
    fetchNextPage: (idRelatorio, pagina) => `/relatorioCativo/getPaginaRelatorio?idRelatorio=${idRelatorio}&pagina=${pagina}&tamanhoPagina=20"`,
    getRelatorioCSV: (idRelatorio, pagina) => `/relatorioCativo/getRelatorioCSV?idRelatorio=${idRelatorio}&pagina=${pagina}&tamanhoPagina=20"`,
    parametros: () => "/relatorioCativo/parametros",
  },
  companies: {
    buscarEmpresaFechado: q => `/companies/sugerir/${q}`,
    fetchCargasEGeracao: companyId => `/medicao/cargasegeracoesempresa/${companyId}`,
    fetch: () => "/companies",
    getBreakEven: (dsitrId, companyId) => `/dashboard/breakeven/${dsitrId}?idEmpresa=${companyId}`,
    getCativoInfo: cnpj => `/companies/search/${cnpj}`,
    getCurvaPerfisAgentes: () => 'dashboard/curvaPerfisAgentes',
    getInfo: id => `/dashboard/${id}`,
  },
  contato: {
    sendMessage: () => "/contato",
  },
  dadosGerais: {
    fetchCidades: estado => `/dadosgerais/cidades/${estado}`,
  },
  relatorios: {
    fetch: () => "/relatorios",
    fetchNextPage: (idRelatorio, pagina) => `/relatorios/getPaginaRelatorio?idRelatorio=${idRelatorio}&pagina=${pagina}&tamanhoPagina=20"`,
    getRelatorioCSV: (idRelatorio, pagina) => `/relatorios/getRelatorioCSV?idRelatorio=${idRelatorio}&pagina=${pagina}&tamanhoPagina=20"`,
    parametros: () => "/relatorios/parametros",
  },
  simuladores: {
    buscarCNPJ: q => `/simuladorEconomia/buscarCNPJ/${q}`,
    buscarEmpresa: q => `/simuladorEconomia/buscarEmpresa/${q}`,
    calcularEconomia: () => '/simuladorEconomia/CalcularEconomia',
    fetchDefaultParametros: () => '/simuladorEconomia/parametros',
    getCativoInfo: cnpj => `/simuladorEconomia/buscarCNPJ/${cnpj}`,
    getInfo: id => `/simuladorEconomia/dadosEmpresa/${id}`,
  },
  user: {
    cadastro: () => "/account/cadastro",
    confirmacaoEmail: () => "/account/confirmacaoEmail",
    enviarEmailCadastro: () => "/account/enviarEmailCadastro",
    update: () => "/account/atualizarUsuario",
  },
};

export default routes;



// WEBPACK FOOTER //
// ./src/services/routes.js